module.exports = __webpack_public_path__ + "static/img/product_1_6.5ea6d57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/product_1_6.png
// module id = 6nsw
// module chunks = 34